<h2>User Preferences</h2>
<div class="grid-x grid-padding-x">
  <div class="medium-6 large-8 cell">
    <div class="grid-x grid-padding-x grid-padding-y small-up-1 large-up-2">
      <div class="cell">
        <rav-icon
          matTooltip="Document import notifications in the bottom right corner of the screen when new documents are added to your account."
          [name]="RavIconCircled.Question"
          class="question"
        >
        </rav-icon>
        Document Import Notifications
      </div>
      <div class="cell">
        <mat-slide-toggle
          data-cy="documentImportNotification"
          [checked]="documentNotificationChecked"
          (change)="onDocumentNotificationChange($event)"
          >{{ documentNotificationChecked ? 'On' : 'Off' }}</mat-slide-toggle
        >
      </div>
    </div>
    <div class="grid-x grid-padding-x grid-padding-y small-up-1 large-up-2">
      <div class="cell">
        <rav-icon
          matTooltip="Automatically refresh folder table views to display new documents when they are added to your account."
          [name]="RavIconCircled.Question"
          class="question"
        >
        </rav-icon>
        Table Auto Refresh On Import
      </div>
      <div class="cell">
        <mat-slide-toggle
          data-cy="tableAutoRefreshOnImportChecked"
          [checked]="tableAutoRefreshOnImportChecked"
          (change)="onTableAutoRefreshOnImportChange($event)"
          >{{ tableAutoRefreshOnImportChecked ? 'On' : 'Off' }}</mat-slide-toggle
        >
      </div>
    </div>
    <div class="grid-x grid-padding-x grid-padding-y small-up-1 large-up-2">
      <div class="cell">
        <rav-icon
          matTooltip="When enabled, a transmission report of the fax status will be sent to your email to state the final status of a fax sent."
          [name]="RavIconCircled.Question"
          class="question"
        >
        </rav-icon>
        Fax Transmission Reports
      </div>
      <div class="cell">
        <mat-slide-toggle
          data-cy="faxTransmissionReportsChecked"
          [checked]="faxTransmissionReportsChecked"
          (change)="onFaxTransmissionReportsChange($event)"
          >{{ faxTransmissionReportsChecked ? 'On' : 'Off' }}</mat-slide-toggle
        >
      </div>
    </div>
  </div>
</div>